function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../locales/keys';
import { formattedCreditCardExpiration, isExpired } from '../../../utilities/credit.card.helper';
var ChangePaymentPopupController = /*#__PURE__*/function () {
  function ChangePaymentPopupController() {
    _classCallCheck(this, ChangePaymentPopupController);
  }
  return _createClass(ChangePaymentPopupController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.instrumentSummaries) {
        this.paymentInstrumentViewModel = {
          paymentInstruments: changesObj.instrumentSummaries.currentValue.map(function (summary) {
            var _summary$StripeAccoun, _summary$StripeAccoun2, _summary$StripeAccoun3;
            return {
              id: summary.Id,
              name: summary.Name,
              isCreditCard: !!summary.CreditCard,
              isCurrencyEntitlement: !!summary.CurrencyEntitlement,
              isStripeAccount: !!summary.StripeAccount,
              expirationDate: formattedCreditCardExpiration(summary),
              flagged: summary.Flagged,
              currentBalance: summary.CurrencyEntitlement && summary.CurrencyEntitlement.CurrentBalance,
              currency: summary.CurrencyEntitlement && summary.CurrencyEntitlement.Currency,
              isExpired: isExpired(summary),
              stripePaymentSummary: "".concat(summary === null || summary === void 0 ? void 0 : (_summary$StripeAccoun = summary.StripeAccount) === null || _summary$StripeAccoun === void 0 ? void 0 : _summary$StripeAccoun.PaymentMethodType, " ").concat(summary !== null && summary !== void 0 && (_summary$StripeAccoun2 = summary.StripeAccount) !== null && _summary$StripeAccoun2 !== void 0 && _summary$StripeAccoun2.PaymentMethodSubType ? "- ".concat(summary === null || summary === void 0 ? void 0 : (_summary$StripeAccoun3 = summary.StripeAccount) === null || _summary$StripeAccoun3 === void 0 ? void 0 : _summary$StripeAccoun3.PaymentMethodSubType) : ''),
              typeName: summary.TypeName
            };
          })
        };
      }
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      this.LocaleKeys = LocaleKeys;
      this.currentPaymentInstrument = this.paymentInstrument;
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.onClose()();
    }
  }, {
    key: "changeSelectedPayment",
    value: function changeSelectedPayment(selectedPaymentId) {
      if (selectedPaymentId !== (this.paymentInstrument && this.paymentInstrument.Id)) {
        this.paymentInstrument = this.instrumentSummaries.find(function (paymentInstrument) {
          return paymentInstrument.Id === selectedPaymentId;
        });
      }
    }
  }, {
    key: "submitPopup",
    value: function submitPopup() {
      this.onSuccess()(this.paymentInstrument);
    }
  }]);
}();
export default {
  template: require('./change.payment.popup.html'),
  bindings: {
    config: '<',
    onClose: '&',
    onSuccess: '&',
    paymentInstrument: '<',
    instrumentSummaries: '<'
  },
  controllerAs: 'ChangePaymentPopupController',
  controller: ChangePaymentPopupController
};